import { memo, useMemo } from 'react';
import OutlineText from './OutlineText';

function hexToRgb(hex) {
    const n = parseInt(hex?.replace('#', '') || '888888', 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
function mixHex(hex, r2, g2, b2, pct) {
    const [r1, g1, b1] = hexToRgb(hex);
    const p = pct / 100, q = 1 - p;
    return `rgb(${Math.round(r1 * p + r2 * q)}, ${Math.round(g1 * p + g2 * q)}, ${Math.round(b1 * p + b2 * q)})`;
}

const TeamsSelectionBox = memo(function TeamsSelectionBox({ styles, team, players }) {
    //console.log("Rendering TeamsSelectionBox", team);
    const teamPlayers = team?.playerIds.map((id) => { return players.find(p => p.id === id) });
    const colourVars = useMemo(() => {
        const c = team?.colour;
        if (!c) return {};
        return {
            "--team-colour": c,
            "--team-colour-light": mixHex(c, 255, 255, 255, 90),
            "--team-colour-dark": mixHex(c, 0, 0, 0, 70),
            "--team-colour-border": mixHex(c, 255, 255, 255, 60),
            "--team-colour-glow": mixHex(c, 0, 0, 0, 40).replace('rgb', 'rgba').replace(')', ', 0.4)'),
        };
    }, [team?.colour]);
    return (
        <div className={`${styles.team}`} style={colourVars}>
            {/*<OutlineText styles={styles} text={team?.name.toUpperCase()} className={styles.title} />*/}
            <div className={styles.teamLetter} >{team?.id}</div>
            <div className={styles.players}>
                {teamPlayers?.map(player => { return <div key={player?.id} className={styles.playerTag} style={{ "--team-colour": team ? team.colour : "#44486E" }}>{player?.connected ? player.name : "Not Connected"}</div> })}
            </div>
        </div>
    )
});

export default TeamsSelectionBox;